var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelLeftClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 3V21M21 11C21 7.229 21 5.343 19.828 4.172C18.656 3.001 16.771 3 13 3H11C7.229 3 5.343 3 4.172 4.172C3.001 5.344 3 7.229 3 11V13C3 16.771 3 18.657 4.172 19.828C5.344 20.999 7.229 21 11 21H13C16.771 21 18.657 21 19.828 19.828C20.999 18.656 21 16.771 21 13V11Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 9L14.892 9.879C13.63 10.879 13 11.379 13 12C13 12.621 13.63 13.121 14.892 14.121L16 15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelLeftClose);
export default __webpack_public_path__ + "static/media/Panel-left-close.5714cd92000b0bf3a498840dcd42afeb.svg";
export { ForwardRef as ReactComponent };